import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/researchers/_authenticated/')({
  beforeLoad: () => {
    throw redirect({ to: '/researchers/projects' });
  },
});
